import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { convertData } from '../../../../../../helpers/value'
import { selectUserType } from '../../../../../../layout/store/slice'
import { USER_TYPE } from '../../../../../../utils/authorization'
import {
  getNoDataComponent,
  getStyleHeightContainer,
  getValueAndTitleCheckbox,
  handleIconDownload,
} from '../../../helper'
import classes from '../../../index.module.scss'
import { changeChecked, selectChecked } from '../../../store/slice'
import {
  TREND_GAIN_PROPRIETARY_TRADING,
  TREND_OPERATING_INCOME,
} from '../constant'
import { selectDataViewByTrend, selectIndicatorById } from '../store/slice'
import Chart from './Chart'

const Trend = ({ id, isDynamicReport, check, isDownloadComponent }) => {
  const dispatch = useDispatch()

  const { getExchangeRate, multiplier } = useFormatCurrency(
    SCREEN.FINANCIAL_ANALYSIS,
  )
  const userType = useSelector(selectUserType)
  const dataByTrend = useSelector(selectDataViewByTrend)
  const indicatorById = useSelector(selectIndicatorById)
  const checkedStore = useSelector(selectChecked(id))

  const checked = checkedStore || check

  const setChecked = (checked) => dispatch(changeChecked({ id, checked }))

  const dataConvert = convertData(
    dataByTrend,
    getExchangeRate,
    indicatorById,
    multiplier,
    ['year'],
  )

  const operatingCheckboxs = TREND_OPERATING_INCOME.map((item) => ({
    ...item,
    ...getValueAndTitleCheckbox(indicatorById, item.value),
  }))
  const gainCheckboxs = TREND_GAIN_PROPRIETARY_TRADING.map((item) => ({
    ...item,
    ...getValueAndTitleCheckbox(indicatorById, item.value),
  }))

  const isNoData = !dataConvert.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  const chart = []
  if (!isDynamicReport) {
    chart.push(...[1, 2])
  } else {
    if (operatingCheckboxs.some(({ value }) => checked.includes(value))) {
      chart.push(1)
    }
    if (gainCheckboxs.some(({ value }) => checked.includes(value))) {
      chart.push(2)
    }
  }

  const isH100 = chart.length === 2
  const isDynamicAndJPG = isDownloadComponent || isDynamicReport

  return (
    <div
      style={{
        height: getStyleHeightContainer(
          isDynamicAndJPG,
          isNoData,
          isH100 ? 550 : 550 / 2,
        ),
      }}
      className={
        !isDynamicAndJPG ? 'py1 dFlex' : 'py1 flexColumn justifyContentBetween'
      }
    >
      {chart.includes(1) && (
        <div
          className={
            !isDynamicAndJPG
              ? 'w50 h100 pr1 flexColumn'
              : `w100 ${isH100 ? classes.h48 : 'h100'} flexColumn`
          }
        >
          <div className="fw600 pb1">
            <Translate value="financialAnalysis.OPERATING_INCOME_BREAKDOWN" />
          </div>
          <Chart
            data={dataConvert}
            isCheckbox={userType?.userTypeId === USER_TYPE.PREMIUM}
            checkboxs={operatingCheckboxs}
            checked={checked}
            setChecked={setChecked}
            isDynamicReport={isDynamicAndJPG}
          />
        </div>
      )}
      {chart.includes(2) && (
        <div
          className={
            !isDynamicAndJPG
              ? 'w50 h100 pl1 flexColumn'
              : `w100 ${isH100 ? classes.h48 : 'h100'} flexColumn`
          }
        >
          <div className="fw600 pb1">
            <Translate value="financialAnalysis.GAIN_PROPRIETARY_TRADING_BREAKDOWN" />
          </div>
          <Chart
            data={dataConvert}
            isCheckbox={userType?.userTypeId === USER_TYPE.PREMIUM}
            checkboxs={gainCheckboxs}
            checked={checked}
            setChecked={setChecked}
            isDynamicReport={isDynamicAndJPG}
          />
        </div>
      )}
    </div>
  )
}

export default Trend
